import { useEffect, useState } from "react";

export default function AdminInvoices() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/invoices.php")
      .then(res => res.json())
      .then(json => {
        if (json.ok) setRows(json.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-extrabold">الفواتير</h2>
        <p className="text-sm text-slate-500">
          إدارة فواتير الاشتراكات
        </p>
      </div>

      <div className="bg-white border rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[800px]">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-right">رقم الفاتورة</th>
              <th className="px-4 py-3 text-center">المبلغ</th>
              <th className="px-4 py-3 text-center">الحالة</th>
              <th className="px-4 py-3 text-center">تاريخ الاستحقاق</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="4" className="px-4 py-6 text-center text-slate-500">
                  جاري التحميل…
                </td>
              </tr>
            )}

            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan="4" className="px-4 py-6 text-center text-slate-500">
                  لا توجد فواتير
                </td>
              </tr>
            )}

            {rows.map(row => (
              <tr key={row.id} className="border-t">
                <td className="px-4 py-3 font-mono">{row.invoice_no}</td>
                <td className="px-4 py-3 text-center">{row.amount} ر.س</td>
                <td className="px-4 py-3 text-center">{row.status}</td>
                <td className="px-4 py-3 text-center">{row.due_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
